
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registro",
      function () {
        return require("private-next-pages/registro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registro"])
      });
    }
  